import { Button } from '@mui/material';
import { ApplicationRevokeForm } from '~/modules/processing-personal/PersonalDataApplicationForm/PersonalDataApplicationRevoke/ApplicationRevokeForm/ApplicationRevokeForm.tsx';
import { ApplicationDocumentPreview } from '~/modules/processing-personal/PersonalDataApplicationForm/components/ApplicationDocumentPreview.tsx';
import { FormButtonGroup } from '../../components/styled.ts';
import { FormDataRevoke } from '../types.ts';

interface IApplicationStepContentRevokeProps {
  current: number;
  isSubmitting: boolean;
  formData?: FormDataRevoke;
  onOptionSignature: () => void;
}

export const ApplicationStepContentRevoke = ({
  current,
  isSubmitting,
  formData,
  onOptionSignature,
}: IApplicationStepContentRevokeProps) => {
  const renderContent = () => {
    switch (current) {
      case 1:
        return <ApplicationRevokeForm formData={formData} />;
      case 2:
        return <ApplicationDocumentPreview />;
      default:
        return null;
    }
  };

  const renderButtons = () => (
    <FormButtonGroup>
      {current === 1 && (
        <Button variant="contained" color="primary" type="submit" disabled={isSubmitting}>
          Продовжити
        </Button>
      )}

      {current === 2 && (
        <Button
          variant="outlined"
          color="primary"
          type="button"
          onClick={onOptionSignature}
          disabled={isSubmitting}
        >
          Відкликати
        </Button>
      )}
    </FormButtonGroup>
  );

  return (
    <>
      {renderContent()}
      {renderButtons()}
    </>
  );
};
